import { forwardRef } from 'react'

// Mantine
import { HoverCard } from '@mantine/core'

// Nextjs
import { Link } from 'react-router-dom'

const Avatar = forwardRef(({ short, ...props }, ref) => {
    return (
        <div
            ref={ref}
            {...props}
            className="select-none h-[32px] w-[32px] bg-gray-200 text-gray-700 text-sm rounded-full flex items-center justify-center"
        >
            {short}
        </div>
    )
})

export default function ProfileAvatar({ profile, noHoverCard = false }) {
    /*
    const avatarUrl = profile.avatar
        ? 'https://wtlltffvwmgvkdwvakua.supabase.co/storage/v1/object/public/avatars/' +
          profile.avatar
        : 'https://api.dicebear.com/9.x/initials/svg?seed=' + profile.short
    */

    if (noHoverCard) {
        return <Avatar short={profile.short} />
    }

    return (
        <HoverCard shadow="md" position="left" withinPortal={true}>
            <HoverCard.Target>
                <Avatar short={profile.short} />
            </HoverCard.Target>

            <HoverCard.Dropdown p="sm">
                <Link
                    to={`/profiles/${profile?.id}`}
                    className="no-underline text-inherit"
                >
                    <div className="flex items-center gap-3">
                        <Avatar short={profile.short} />

                        <div className="flex flex-col">
                            <span className="font-medium text-sm text-gray-900">
                                {profile?.name}
                            </span>
                            <span className="text-xs text-gray-500">
                                {profile?.email}
                            </span>
                            {profile?.group && (
                                <span className="text-xs text-gray-400 mt-0.5">
                                    {profile.group.name}
                                </span>
                            )}
                        </div>
                    </div>
                </Link>
            </HoverCard.Dropdown>
        </HoverCard>
    )

    // Backup : version avec Avatar Mantine au lieu du div
    // return (
    //     <HoverCard
    //         shadow="md"
    //         position="left"
    //         withinPortal={true}
    //         closeDelay={0}
    //     >
    //         <HoverCard.Target>
    //             <Avatar
    //                 className="cursor-pointer"
    //                 color={profile.color ?? 'gray'}
    //                 radius="xl"
    //                 size={32}
    //                 src={avatarUrl}
    //             >
    //                 {profile.short}
    //             </Avatar>
    //         </HoverCard.Target>
    //
    //         <HoverCard.Dropdown miw={400}>
    //             <div className="flex flex-col gap-5">
    //                 {profile && (
    //                     <div className="flex gap-5 items-center w-full">
    //                         <Avatar
    //                             color={profile.color ?? 'gray'}
    //                             radius={100}
    //                             size={80}
    //                             src={avatarUrl}
    //                         >
    //                             {profile.short}
    //                         </Avatar>
    //
    //                         <div className="flex flex-col w-full">
    //                             <span className="font-medium">
    //                                 {profile?.name}
    //                             </span>
    //
    //                             <span className="text-gray-400">
    //                                 {profile?.email}
    //                             </span>
    //
    //                             {profile?.group && (
    //                                 <span className="text-gray-400">
    //                                     {profile.group.name}
    //                                 </span>
    //                             )}
    //                         </div>
    //                     </div>
    //                 )}
    //
    //                 <Link to={`/profiles/${profile?.id}`}>
    //                     <Button fullWidth variant="default" size="xs">
    //                         Voir le profil
    //                     </Button>
    //                 </Link>
    //             </div>
    //         </HoverCard.Dropdown>
    //     </HoverCard>
    // )
}
